import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Welcome from "../views/Welcome";
import Login from "../views/account/Login";
import Signup from "../views/account/Signup";
import RecoverAccount from "../views/account/RecoverAccount";
import PostView from "../views/PostView";
import ViewProfile from "../views/ViewProfile";
import EditProfile from "../views/EditProfile";
import Account from "../views/Account";
import Terms from "../views/account/Terms";
import Activate from "../views/account/Activate";
import ChangePassword from "../views/account/ChangePassword";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Welcome,
    name: 'welcome'
  },
  {
    path: '/account',
    component: Account,
    children: [
      {
        path: 'login',
        component: Login,
        name: 'login'
      },
      {
        path: 'signup',
        component: Signup,
        name: 'signup'
      },
      {
        path: 'recover-account',
        component: RecoverAccount,
        name: 'recoverAccount'
      },
      {
        path: 'terms',
        component: Terms,
        name: 'terms'
      },
      {
        path: 'activate/:uid/:token',
        component: Activate,
        name: 'activateAccount'
      },
      {
        path: 'change-password/:uid/:token',
        component: ChangePassword,
        name: 'changePassword'
      }
    ]
  },
  {
    path: '/posts',
    component: Home,
    name: 'home'
  },
  {
    path: '/post/:post_id',
    component: PostView,
    name: 'postView'
  },
  {
    path: '/profile/view/:username',
    component: ViewProfile,
    name: 'viewProfile'
  },
  {
    path: '/profile/edit',
    component: EditProfile,
    name: 'editProfile'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.user.authToken !== null;
  const routesAuthorizedForAnonymous = [
      'welcome', 'signup', 'login', 'activateAccount', 'terms', 'recoverAccount', 'changePassword'
  ];

  if (!routesAuthorizedForAnonymous.includes(to.name) && !isAuthenticated){
    next({ name: 'login' });
  }
  else if(to.name === 'welcome' && isAuthenticated){
    next({ name: 'home'});
  }
  else {
    next();
  }

});

export default router
